export default function appWorkspaceMenuIsOpen(state) {
  return state.appWorkspaceMenuIsOpen;
}
